var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dia, util, shapes } from '@joint/plus';
import { VisioArchive, VisioShape, types, util as vsdUtil } from '@joint/format-visio';
export var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    function exportPaperToVSDX(paper) {
        return __awaiter(this, void 0, void 0, function () {
            var archive, vsdDocument, masters, page0, blob;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, VisioArchive.fromURL('./assets/bpmn.vsdx')];
                    case 1:
                        archive = _a.sent();
                        vsdDocument = archive.document;
                        masters = vsdDocument.getMastersNameMap();
                        page0 = vsdDocument.getPages()[0];
                        return [4 /*yield*/, page0.fromPaper(paper, {
                                exportLink: function (_linkView, vsdPage) { return __awaiter(_this, void 0, void 0, function () {
                                    var master;
                                    return __generator(this, function (_a) {
                                        master = masters['Sequence Flow'];
                                        return [2 /*return*/, VisioShape.fromMaster(master, vsdPage)];
                                    });
                                }); },
                                exportElement: function (elementView, vsdPage) { return __awaiter(_this, void 0, void 0, function () {
                                    var model, paper, master, border, masterType, vsdShape, center, paperSize, x, y, text, data, iconType, vsdIcon, row, formatCell, format, index, row;
                                    return __generator(this, function (_a) {
                                        switch (_a.label) {
                                            case 0:
                                                model = elementView.model, paper = elementView.paper;
                                                switch (model.get('type')) {
                                                    case 'bpmn2.Event': {
                                                        border = model.attr('border').borderType;
                                                        masterType = border === 'thick' ? 'End Event' : 'Start Event';
                                                        master = masters[masterType];
                                                        break;
                                                    }
                                                    case 'bpmn2.Activity': {
                                                        master = masters['Task'];
                                                        break;
                                                    }
                                                    case 'bpmn2.Gateway': {
                                                        master = masters['Gateway'];
                                                        break;
                                                    }
                                                }
                                                if (!master) {
                                                    return [2 /*return*/, null];
                                                }
                                                return [4 /*yield*/, VisioShape.fromMaster(master, vsdPage)];
                                            case 1:
                                                vsdShape = _a.sent();
                                                center = model.getBBox().center();
                                                paperSize = paper.getArea();
                                                x = vsdUtil.fromPixels(center.x, VisioUnitType.IN);
                                                y = vsdUtil.fromPixels(paperSize.height - center.y, VisioUnitType.IN);
                                                // set position related Visio cells
                                                vsdShape.setCell(VisioCellName.PinX, { value: x, units: VisioUnitType.IN });
                                                vsdShape.setCell(VisioCellName.PinY, { value: y, units: VisioUnitType.IN });
                                                text = model.attr('label').text;
                                                vsdShape.setText(text);
                                                data = vsdShape.getComputedSection(VisioSectionType.Property);
                                                switch (model.get('type')) {
                                                    case 'bpmn2.Activity': {
                                                        iconType = model.attr('icon').iconType;
                                                        vsdIcon = bpmnToVisioIcon[iconType];
                                                        if (vsdIcon) {
                                                            row = data.getRow('BpmnTaskType');
                                                            if (!row) {
                                                                break;
                                                            }
                                                            formatCell = row.getCell('format');
                                                            format = formatCell.value || '';
                                                            index = format.split(';').indexOf(vsdIcon);
                                                            if (index > -1) {
                                                                row.setCell(VisioCellName.Value, {
                                                                    value: vsdIcon,
                                                                    formula: "INDEX(".concat(index, ",Prop.BpmnTaskType.Format)")
                                                                });
                                                            }
                                                        }
                                                        break;
                                                    }
                                                    case 'bpmn2.Gateway': {
                                                        row = data.getRow('BpmnMarkerVisible');
                                                        row.setCell(VisioCellName.Value, {
                                                            value: '1',
                                                            formula: null,
                                                            units: VisioUnitType.BOOL
                                                        });
                                                        break;
                                                    }
                                                }
                                                return [2 /*return*/, vsdShape];
                                        }
                                    });
                                }); }
                            })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, archive.toVSDX()];
                    case 3:
                        blob = _a.sent();
                        util.downloadBlob(blob, 'project.vsdx');
                        return [2 /*return*/];
                }
            });
        });
    }
    function addDemoCells(graph) {
        var bpmn2 = shapes.bpmn2;
        var start = new bpmn2.Event({
            position: { x: 50, y: 280 },
            attrs: { label: { text: 'Received order' } },
        }).addTo(graph);
        var a1 = new bpmn2.Activity({
            position: { x: 150, y: 250 },
            attrs: {
                label: { text: 'Retrieve data' },
                icon: { iconType: 'script' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: start.id },
            target: { id: a1.id },
            attrs: { line: { stroke: '#AAA' } }
        }).addTo(graph);
        var a2 = new bpmn2.Activity({
            position: { x: 350, y: 250 },
            attrs: {
                label: { text: 'Approve Data' },
                icon: { iconType: 'user' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: a1.id },
            target: { id: a2.id },
            attrs: { line: { stroke: '#AAA' } }
        }).addTo(graph);
        var e1 = new bpmn2.Gateway({
            position: { x: 550, y: 270 },
            attrs: {
                label: { text: 'Approved?' },
                icon: { iconType: 'exclusive' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: a2.id },
            target: { id: e1.id },
            attrs: { line: { stroke: '#AAA' } }
        }).addTo(graph);
        var a3 = new bpmn2.Activity({
            position: { x: 750, y: 100 },
            attrs: {
                label: { text: 'Order items' },
                icon: { iconType: 'script' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: e1.id },
            target: { id: a3.id },
            vertices: [{ x: 579, y: 150 }],
            attrs: { line: { stroke: '#AAA' } },
            labels: [{ attrs: { text: { text: 'YES' } } }]
        }).addTo(graph);
        var a4 = new bpmn2.Activity({
            position: { x: 750, y: 400 },
            attrs: {
                label: { text: 'Send rejection mail' },
                icon: { iconType: 'script' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: e1.id },
            target: { id: a4.id },
            vertices: [{ x: 579, y: 450 }],
            attrs: { line: { stroke: '#AAA' } },
            z: -1,
            labels: [{ attrs: { text: { text: 'NO' } } }]
        }).addTo(graph);
        var e2 = new bpmn2.Event({
            position: { x: 900, y: 130 },
            attrs: {
                label: { text: 'Order processed' },
                border: { borderType: 'thick' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: a3.id },
            target: { id: e2.id },
            attrs: { line: { stroke: '#AAA' } }
        }).addTo(graph);
        var e3 = new bpmn2.Event({
            position: { x: 900, y: 430 },
            attrs: {
                label: { text: 'Order not\nprocessed' },
                border: { borderType: 'thick' }
            }
        }).addTo(graph);
        new bpmn2.Flow({
            source: { id: a4.id },
            target: { id: e3.id },
            attrs: { line: { stroke: '#AAA' } }
        }).addTo(graph);
    }
    var VisioCellName, VisioUnitType, VisioSectionType, appGraph, appPaper, bpmnToVisioIcon;
    return __generator(this, function (_a) {
        VisioCellName = types.VisioCellName, VisioUnitType = types.VisioUnitType, VisioSectionType = types.VisioSectionType;
        appGraph = new dia.Graph({ type: 'bpmn' });
        appPaper = new dia.Paper({
            el: document.getElementById('paper'),
            width: 1000,
            height: 600,
            model: appGraph,
            async: true,
            interactive: false,
            defaultRouter: { name: 'normal' },
            defaultConnectionPoint: { name: 'boundary', args: { stroke: true } }
        });
        document.getElementById('export-button').onclick = (function () { return exportPaperToVSDX(appPaper); });
        addDemoCells(appGraph);
        bpmnToVisioIcon = {
            script: 'Script',
            user: 'User'
        };
        return [2 /*return*/];
    });
}); };
